export const actionTexts = {
  notLoggedIn: 'Sign in to continue',
  incompleteProfile: 'Complete profile',
  ready: 'Go to checkout',
};

export const getActionText = ({ isLoggedIn, profileIsComplete }) => {
  if (!isLoggedIn) return actionTexts.notLoggedIn;
  if (!profileIsComplete) return actionTexts.incompleteProfile;
  return actionTexts.ready;
};
